import * as Mobx from "mobx"
import * as MobxPreact from 'mobx-preact';
import * as P from "preact";
import * as PR from 'preact-router';
import {JSX} from "preact";
export var state = Mobx.observable;
export var computed = Mobx.computed;
export var autorun = Mobx.autorun;
export var action = Mobx.action;
export var mobx = Mobx;
export var observer = MobxPreact.observer;
export var Preact = P;
export import JSX = JSX
import { Utils } from "./Utils";
export var PreactRouter = PR;
export var h = P.h;
export type CallFaunaFunctionType = (name :string,args,asMain?:boolean) => any;
export var RouteKeys = ["path","key","component","data","static"];
import { nanoid } from 'nanoid';
export var UID = nanoid;
import { preventEvent } from './Html';
var router : Router;
export type buttonProps = JSX.IntrinsicElements["button"];
export type aProps = JSX.IntrinsicElements["a"];
export interface PS {children? : any}
export type divProps = JSX.IntrinsicElements["div"];
// TYPES
export type DeepAny<T> = {
    [P in keyof T]?: any;
};
export type DeepPartial<T> = {
    [P in keyof T]?: Partial<T[P]>;
};
export type GetPropsContext = {
    matches : any;
    isServerSide:boolean;
    url:URL;
    callFaunaFunction : CallFaunaFunctionType;
}
export type GetPropsReturnType = {
    faunaFunctionName? : string;
    faunaFunctionArgs?:any[];
    // nodeFound?:boolean;
    // redirect? : string;
}
export type FaunaIndexType = {
    data:any;
    index:string;
    args:any;
}
export interface IBaseProps {
    path?:string;
    matches?:any;
    url?:string;
}
export class ComponentView<P> extends P.Component<P & IBaseProps, {}>{

    render(props:P & IBaseProps,state){
        return <div></div>
    }
    static async GetProps(context:GetPropsContext){
        return null
    }
    // static async OnEnter(){
    //     console.log("OnEnter");
        
    // }
    // static async BeforeExit(){
    //     console.log("BeforeExit");

    // }
}


export interface SaveFaunaObj{
    doc:DocStore;
    data:{
        ref:string,
        collection:string,
        data:any,
    }
}
export interface Route {component:typeof ComponentView,path:string,static?:boolean,data?:any}
export interface FaunaDoc {ts:number,data:any,ref:any,merge?:any}

export interface StoreInfo  {
    ref: any,
    ts: any,
    collection:string,
    edited:boolean,
    edits:any
    deleted?:boolean;
    doNotUpload?:boolean;
    instancer?:Store,
    clone : Store,
    storesBykey:any,
    faunaState,
    setFrom2:boolean,
    gblId:number,
}
// function runCmd<P>(cmdType:ComponentViewClass<P>,args:(P) | null){
// }
// runCmd(Test,{})

// FROM PREACT-ROUTER
const EMPTY = {};
function exec(url, route, opts) {
    
	const reg = /(?:\?([^#]*))?(#.*)?$/;
    const c = url.match(reg);
	const matches = {};
	let ret;

	if (c && c[1]) {
		let p = c[1].split('&');
		for (let i=0; i<p.length; i++) {
			let r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
    console.log("url",url,route)
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	let max = Math.max(url.length, route.length);
	for (let i=0; i <max; i++) {
		if (route[i] && route[i].charAt(0)===':') {
			let param = route[i].replace(/(^:|[+*?]+$)/g, ''),
				flags = (route[i].match(/[+*?]+$/) || EMPTY)[0] || '',
				plus = ~flags.indexOf('+'),
				star = ~flags.indexOf('*'),
				val = url[i] || '';
			if (!val && !star && (flags.indexOf('?')<0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i).map(decodeURIComponent).join('/');
				break;
			}
		}else if (route[i]!==url[i]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret===false) return false;
	return matches;
}
function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}




// MISC
export function GetRefId(obj){
    return obj.ref["@ref"].id
}

/*  FAUNA STATE WORKFLOW
    set fauna data function
        create new arrays and objects
        if doc is clone set fauna data on connected clone ? 

    Load fauna data from server
    router create or get docs
        sets fauna data on docs if doc has clone it will upldate it as well
    create clone of doc 
        sets fauna data on new clone.
        if clone is deep it will use/create doc clones.
        edit clone: pet.name = "Name" ;
        get save data from cloned doc
        save to fauna
        set fauna data to doc and clone 

*/

// FAUNA STATE
function setChildFromFaunaObj(src,target:any,stores,ui:Router,useClone?:boolean){
    for (var key in src){
        
        var value = src[key];
        if(value == undefined || key == "ui" || key == "info"){
            continue;
        }

        target[key] = setFromFaunaObj(src[key],target[key],stores && stores[key],ui);
        

    }
}
function setFromFaunaObj(src,target,storeObj,ui:Router){
    if(Array.isArray(src)){

        var arr = [];
        for (let i = 0; i < src.length; i++) {
            const element = src[i];
            if(typeof storeObj == "function"){
                if(storeObj.isStoreClass){

                    var store = target instanceof Store ? store : new storeObj(ui) as Store;
                    store.setFaunaState(element)
                    arr.push(store)

                }else{

                    var date = new Date(element);
                    arr.push(arr);
                }



            }else{
                var newItem = setFromFaunaObj(element,null,storeObj,ui);
                arr.push(newItem);
            }

        }
        return arr;
    }else if(Utils.isObject(src)){
        if(src.index){ // PAG INDEX OF VALUES   

            var pag :PagStore<any> = target instanceof PagStore ? target :  ui._createStoreFromFaunaDoc(src,false) as any;
            pag.setFaunaState(src)
            return pag;

        }else if(src.data && src.ref){ // MY FAUNA DOC
            var id = src.ref.id || src["@ref"].id
            var doc = ui.getDocByRef(id);
            if(!doc){
                if((ui as any).log){
                    console.log("NO DOC",src.ref.id,src.ref,src);
                }
                
                doc = ui._createStoreFromFaunaDoc(src,false) as DocStore;
            }

            doc.setFaunaState(src);

            return doc;
            

        }else if(src["@ref"]){ // DID NOT USE FAUNA HELPER TO GET DOC OR JUST KEF OF OTHER DOC
            var doc = ui.getDocByRef(src["@ref"].id);

            if(!doc){
                doc = ui._createStoreFromFaunaDoc(src,false) as DocStore;
                doc.info.ref = src;
            }

            return doc;

        }else{ // object

            var obj = {};
            setChildFromFaunaObj(src,obj,storeObj,ui)
            return obj;

        }
    }else{

        // date
        if(typeof storeObj == "function"){
            var date = new Date(src);
            return date;
        }else{
            return src;

        }
    }
}


function setChildCloneObj(instancer,clone,router:Router){
    for (var key in instancer){
        if(key == "ui" || key == "info"  || instancer[key] == undefined ){
            continue;
        }

        var result = setCloneObj(instancer[key],router);
        clone[key] = result;

    }
}
var alreadyCloned = [];
var x = 0;
function setCloneObj(instancer,router:Router){
    
    if(instancer instanceof Store){
        
        if(!alreadyCloned.includes(instancer)){
            alreadyCloned.push(instancer);
            x++;
            var t = x;
            
            var clone =  instancer._createClone3();
            if(!clone){
                console.error("NO CLONE",t ,instancer);
            }
        }

        return instancer.clone;


    }else if(Array.isArray(instancer)){

        var arr = [];
        for (let i = 0; i < instancer.length; i++) {
            var newItem = setCloneObj(instancer[i],router);
            if(!newItem){
                console.log("noNewItemArray",newItem,instancer, Utils.StackTrace());
            }
            arr.push(newItem);
        }
        
        return arr;

    }else if (Utils.isObject(instancer)){
        
        var obj = {};
        setChildCloneObj(instancer,obj,router)
        return obj;

    }else{

        return instancer

    }


}


function getSaveData(src:any){
    // NEED TO SEARCH FOR CHILD STORES AND DOC STORES. DOC STORES KEY PATHS ARE UNKOWN NEED TO SEARCH THROUGH ENTIRE OBJECT 
    if(Array.isArray(src)){

        var arr = [];
        for (let i = 0; i < src.length; i++) {
          const element = src[i];
          var newItem = getSaveData(element);
          arr.push(newItem)
        }
        return arr;

    }else if(src instanceof DocStore){

        return DocStore.CreateRawRefObject(src.ref,src.collection)
    }else if(src instanceof Date){

        return src.getTime()
        
    }else if(Utils.isObject(src) || src instanceof Store){

        var obj = {};
        for(var key in src){

            var value = src[key];
            if(value == undefined || key == "ui" || key == "info"){
                continue;
            }

            obj[key] = getSaveData(value)

        }
        return obj;

    }else{

        return src;
    }

}





// ROUTER
export class ComponentRoute{
    propsFunction:any;
    node:any;
}
export class ComponentRouter{
    ui:Router;
    @state routes :ComponentRoute[] = [];
    @state curIndex = 0;
    @state curRoute : ComponentRoute;
    @state curProps : any;
    autoRunRenderPropsDisposer : any;

    constructor(ui:Router){
        this.ui = ui;
        // if(this.autoRunRenderPropsDisposer){
        //     this.autoRunRenderPropsDisposer();
        //     this.componentRouteIndex = 0;
        //     this.curComponentRoute = null;
        //     this.curComponentRouteProps = null;
        //     this.componentRoutes = [];
        // }
    }
    @action _setComponentRoute = (route:ComponentRoute) => {
        if(this.autoRunRenderPropsDisposer){
            this.autoRunRenderPropsDisposer();
        }
        this.curIndex = this.routes.indexOf(route);
        this.curRoute = route;
        this.autoRunRenderPropsDisposer = autorun(()=>{
    
            this.curProps = route.propsFunction()
        })

        // this.activeNode = null;

        
    }
    @action goTo(node:any,propsFunction?:Function){
        console.log("goToComponentRoute",node);
        
        if(!node){
            
        }
        if(this.curIndex > this.routes.length - 2){

        }
        var route = new ComponentRoute();
        route.node = node;
        route.propsFunction = propsFunction;
        this.routes.push(route);
        this._setComponentRoute(route);

    }
    @action goBack  = () =>{
        console.log("goBack");
        
        Utils.RemoveFromArray(this.routes[this.curIndex],this.routes);
        this.curIndex--;
        if(this.routes.length > 0){

            var componentRoute = this.routes[this.curIndex];
            console.log("componentRoute",componentRoute);
            
            this._setComponentRoute(componentRoute);

        }else{
            if(this.autoRunRenderPropsDisposer){
                this.autoRunRenderPropsDisposer();
            }
            this.curRoute = null;
            this.curProps = null;
            console.log("NO COMPONENT ROUTE");
            
        }

    }
    render(){
        var RenderNode = this.curRoute.node;
        return <RenderNode {...this.curProps}></RenderNode>
    }
}
export interface RouterProps extends IBaseProps{
    url?:string, // NAVIGATE TO URL
    page?:Route, // PASS ROUTE INSTEAD OF URL THAT WAY IT DOESN'T HAVE TO SEARCH FOR IT 
    pageProps?:any, // PASS PROPS TO ROUTE... USED WITH PAGE^^
    routes:{Obj:any,Arr:any[]}; // GENEREATED ROUTES
    devMode?:boolean; // USED TO ENABLE DEV FEAUTURES
}
@observer export class Router<P = {}> extends ComponentView<P & RouterProps>{
    routes :any; //{[key:string]:Route}
    routesArr : Route[];
    activeNode : Route; // CANNOT DO MATCHING WITH OBSERVABLE
    @state count = 1;
    nodeProps;
    @state url : URL;
    origin : string;
    serverSide = (typeof window as any === "undefined");
    devMode:boolean;
    @state docs:DocStore[] = [];
    pags:PagStore<any>[] = [];
    
    deletedDocs:DocStore[] = [];
    contextCallFaunaFunction : CallFaunaFunctionType;

    constructor(props:P & RouterProps){
        super(props as any);
        this.routes = props.routes.Obj;
        this.routesArr = props.routes.Arr;
        this.devMode = props.devMode;
        router = this;
    }

    addEventListeners(){
        if(!window){return;}

        window.addEventListener('popstate', ( event ) => {
            console.log("POP location: " + document.location + ", state: " + JSON.stringify(event.state));

            
            this.goToUrl(location.pathname,true);
        });
    }

    // NAV
    getPrevPathNameFromUrl(){
        var split = this.url.pathname.split("/");
        split.splice(split.length - 1,1);
        return split.join("/");
    }
    getPath(obj){
        return obj.path;
    }
    _computeConfigPath(obj){
        console.log("_computeConfigPath",obj);
        
        for(var key in obj){
            if(!RouteKeys.includes(key)){
                var child = obj[key];
                this.routesArr.push(child);
                this._computeConfigPath(child);
            }

        }
        
    }
    // return false if you don't want to navigate
    onAboutToNavigate(configNode){
        return true;
    }
    onComponentEnterDone(){
    }
    onComponentEnter(){
    }

    // NAV
    getConfigNodeByUrl(urlPath){
        
        for (let i = 0; i < this.routesArr.length; i++) {
            const element = this.routesArr[i];
            const matches = exec(urlPath,element.path,{});
            if(matches){                
                return {component:element,matches:matches};
            }       
        } 
    }
    @action _setActiveNode(node,props,url:URL){
        console.log("_setActiveNode",node,node,props,url)
        this.count++;
        this.activeNode = node;
        this.nodeProps = props;
        this.url = url;




    }
    @action async goToByUser(routeNode,props?,dontAddToHistory?:boolean,urlPath?:string){
        
        const route = routeNode as Route;
        console.log("route",route);

        if(this.activeNode && (this.activeNode.component as any).BeforeExit){
            const exitValue = await (this.activeNode.component as any).BeforeExit();
        }

        
        const url = new URL(this.origin + urlPath || route.path);
        const newUrl = urlPath || route.path;
        if (typeof history!=='undefined' && !dontAddToHistory) {
            history.pushState({}, "page 2", newUrl);
        }   

        if(this.onAboutToNavigate(route) === false){
            console.log("not navigating to ",routeNode,props);
            return;
        }
        this.onComponentEnter()
        
        if(route.component.GetProps){
            const pageProps = await route.component.GetProps({
                matches:props.matches,
                callFaunaFunction:this.contextCallFaunaFunction,
                isServerSide:false,
                url:url,
    
            });
            props = {matches:props.matches,...pageProps}
        }else{
            props = {matches:props.matches}
        }

        
        this.onComponentEnterDone();

        // TRIGGERS RE RENDER
        var prevNode = this.activeNode;
        console.log("prevNode",prevNode.component,route.component);

        this._setActiveNode(route,props,url);

        // DON'T RESET SCROLL ON SAME ROUTE CHANGE
        if(prevNode != route){
            window.scrollTo(0, 0);

        }else{
            console.log("MATCHING NODE");
            
        }

        // this.activeNode = node;
        

    }
    async goToUrl(urlPath:string,dontAddToHistory?:boolean){


        var element = this.getConfigNodeByUrl(urlPath);
        if(element){
            return await this.goToByUser(element.component,{matches:element.matches},dontAddToHistory,urlPath)
        }
        
        if(this.routes.notfound){
            await this.goToByUser(this.routes.notfound,null,dontAddToHistory,urlPath);
            
        }else{
            console.log("NO DEFAULT,ERROR");
            
        }
        
    }
    goToUrlSync(urlPath:string,props?:any){
        console.log("urlPatsssh",this.origin + urlPath);
        
        const element = this.getConfigNodeByUrl(urlPath);
        console.log("element",element)
        const url = new URL(this.origin + urlPath);

        if(element){
            return this._setActiveNode(element.component,{matches:element.matches,...props},url);
        }

        if(this.routes.notfound){
            return this._setActiveNode(this.routes.notfound,{...props},url);

        }
        console.log("NO DEFAULT,ERROR");

        // console.log("SYNC",element,{matches:element.matches,...props},props);
        
  
    }
    @action routeFromLink = (node,doNotNav?:boolean) => {
        
        // only valid elements
        if (!node || !node.getAttribute) return;
    
        let href = node.getAttribute('href'),
            target = node.getAttribute('target');
    
        // ignore links with targets and non-path URLs
        if (!href || !href.match(/^\//g) || (target && !target.match(/^_?self$/i))) return;
    
        if(doNotNav){
            var url = new URL(this.origin + href);
            this.url = url;
            history.pushState({},"URL Rewrite Example",url.pathname)
            return
        }
        // attempt to route, if no match simply cede control to browser
        return this.goToUrl(href);
    }
    startFromRoute(urlPath:string,node:Route,props:any){
        const url = new URL(this.origin + urlPath);
        this._setActiveNode(node,props,url);
        
    }




    getDocByRef(id:string){
        if(!id){return;}
        return this.docs.find(doc => doc.ref == id)
    }

    _setDoc(fObj){
        
        var curDoc = this.getDocByRef(fObj.ref["@ref"].id);
        
        if(!curDoc){
            curDoc = this._createStoreFromFaunaDoc(fObj) as DocStore;
            
        }
        if(curDoc){
            curDoc.set(fObj);
            return curDoc
        }

    }
    setDocs(fObjs){
        console.warn("OLD func setDocs")

        if(Array.isArray(fObjs)){

            var arr = [];
            for (let i = 0; i < fObjs.length; i++) {
                const fObj = fObjs[i];
                arr.push(this._setDoc(fObj));
            }
            return arr;

        }else{

            return this._setDoc(fObjs);

        }

    }
    updateCreated(faunaDocs:FaunaDoc[],docStores:DocStore[]){
        console.log("updateDocs",faunaDocs,docStores);
        
        for (let i = 0; i < faunaDocs.length; i++) {
            const faunaDoc = faunaDocs[i];
            docStores[i].set(faunaDoc)
        }
    }

    @action deleteDoc(doc:DocStore){
        Utils.RemoveFromArray(doc,this.docs);
        this.deletedDocs.push(doc);
        console.log("this.pags",this.pags,this.pags.length);
        
        // REMOVE FROM PAGS
        for (let i = 0; i < this.pags.length; i++) {
            var removed = Utils.RemoveFromArray(doc,this.pags[i].data);
            if(removed && doc.clone && this.pags[i].clone){
                Utils.RemoveFromArray(doc.clone,this.pags[i].clone.data);
            }
        }
        doc.info.deleted = true;

    }


    @action _createStoreFromFaunaDoc(fDoc,set = true):PagStore<any> | DocStore{
        return null;
    }
    @action _createFromFauna(fDoc){
    }
    @action createFromFauna(fDoc){
        console.warn("OLD func createFromFauna")
        
        if(Array.isArray(fDoc)){
            var arr = [];
            for (let i = 0; i < fDoc.length; i++) {
                const doc = fDoc[i];
                arr.push(this._createFromFauna(doc))
            }
            return arr;
        }else{
            return this._createFromFauna(fDoc)
        }
    }


    // NEW
    @action _parseFaunaDoc(fDoc,useClone:boolean){
        
        if(fDoc["@ref"]){
            // var ref = fDoc["@ref"].id;
            // console.log("@ref",fDoc,ref);

            var doc = this.getDocByRef(ref)

        }else if(fDoc.ref){
            var ref = fDoc.ref["@ref"].id;


            var doc = this.getDocByRef(ref)
            // console.log("doc",doc);
            // console.log(".ref",fDoc,ref,doc); 


        }

        if(!doc){

            var created =  this._createStoreFromFaunaDoc(fDoc,false) as any;
            created.setFaunaState(fDoc,useClone);
            return created;
        }else{

            doc.setFaunaState(fDoc,useClone);
            return doc;
        }
        
    }
    @action parseFaunaDocs(fDocs){
        if( Array.isArray(fDocs) ){
            var arr :DocStore | PagStore<any>[] = [];
            for (let i = 0; i < fDocs.length; i++) {
                const element = fDocs[i];
                var doc = this._parseFaunaDoc(element,false);
                // console.log("getStoreFromFaunaDoc",doc,element);
                
                if(!doc){continue;}
                arr.push(doc as any);
                
            }
            return arr;
        }
        
        var doc = this._parseFaunaDoc(fDocs,false);
        return doc;

    }
    @action convertFromIndexArray(arr:any[],indexName):any{
    }

    render(){


        if(this.activeNode){
            console.log("this.activeNode",this.activeNode)
            const View = this.activeNode.component;
            return <View  {...this.nodeProps} count={this.count}  ui={this}></View>
            // return <button onClick={this.onClick} >{"active" + this.count}</button>

        }

        return <div>
            <div>No Active Node</div>
            <button >{this.count}</button>
        </div>


    }


    static _getRouteFromUrl(url,routes):{node:Route,matches:any} {
        for(var key in routes){
            var child = routes[key];

            if(!RouteKeys.includes(key)){
                const matches = exec(url,child.path,key);
                
                if(matches){
                    return  {node:child,matches:matches};
                }

                const found = Router._getRouteFromUrl(url,child);
                if(found){
                    return found;
                }
            }

        }
    }
    static GetRouteFromUrl(url:string,routes):{node:Route,matches:any}{
        var routeData = Router._getRouteFromUrl(url,routes);
        if(routeData){
            return routeData;
        }else if(routes.notfound){
            return {node:routes.notfound,matches:{}}
        }else{
            
            console.log("could not find route");
        }
    }
    static _addRouteToArray(routes,arr) {

        for(var key in routes){
            var child = routes[key];
            if(!RouteKeys.includes(key)){
                arr.push(child)
                 Router._addRouteToArray(child,arr);
                 
            }
        }
        return arr;
    }
    
    static GetRoutesAsArray(routes){
        var arr = [];
        Router._addRouteToArray(routes,arr);
        return arr;
    }

}


// COMPONENTS
export interface LinkProps extends aProps{
    route?:any;
    style?:any;
    class?:string;
    href?:string;
    title?:string;
    onClick?:any;
    doNotNav?:boolean;
    regLink?:boolean;
}
export class Link extends ComponentView<LinkProps>{
        

    onClick = (e) => {
        console.log("click",e,this.props);
        if(this.props.doNotNav){
            e.preventDefault();
            router.routeFromLink(e.currentTarget || e.target || this, this.props.doNotNav );
            return;
        }

        preventEvent(e);
        e.stopImmediatePropagation();
        if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button!==0) return;
        if(this.props && this.props.onClick &&  this.props.onClick !== undefined){this.props.onClick()}
        router.routeFromLink(e.currentTarget || e.target || this, this.props.doNotNav );
        return preventEvent(e);
    }


  
    render(){
        const href = this.props.href || (this.props.route && this.props.route.path);
        if(href){
            return <a 

            {...this.props} 
            routerLink 
            onClick={ this.props.onClick ?  this.props.onClick :  this.props.regLink ? null : this.onClick} 
            href={href}
            route={null} >

          </a>
        }else{
            return <button {...this.props} ></button>
        }

    }


}


// STORES
var gblId = 0; 
export class Store {
    info : StoreInfo

    ui:Router;
    
    constructor(router:Router){
        this.ui = router;
        
    }

    @action _setObj(src,target,edits?:any,storesByKey?:any,log?:boolean){
        if(log){
            console.log("_setObj",src,target,edits,storesByKey);
        }


        for (var key in src){
            var srcChild = src[key];
            var targetChild = target && target[key];
            var editChild = edits && edits[key];
            var storesByKeyChild = storesByKey && storesByKey[key];
            log && console.log("Key",key);
            
            if(srcChild == targetChild){
                // console.log("MATCH",srcChild,targetChild,key);
                if(edits){
                    edits[key] = srcChild;
                }
                continue;
            }


            if(targetChild instanceof Store){
            
                targetChild.set(srcChild);

            } else if(typeof storesByKeyChild == "function"){ // CREATE NEW DOC STORE
                log && console.log("function")

                
                if(Array.isArray(srcChild)){
                    if(Array.isArray(targetChild) && srcChild[0] instanceof Store){ // IF SET DOCSTORE[] FROM FAUNA OBJ[] 
                        target[key] = srcChild;
                    }else{
                        target[key] = [];
                        for (let i = 0; i < srcChild.length; i++) {
                            const element = srcChild[i];
                            var newStore = new storesByKeyChild(this.ui) as Store;
                            console.log("newStore",element, newStore);
                            
                            newStore.set(element);                        
                            target[key].push(newStore)
                        }
                    }

            
                }else{

                    var newStore = new storesByKeyChild(this.ui) as Store
                    target[key] = newStore;
                    newStore.set(src[key]);

                }

                
            } else if(srcChild && srcChild.index){ // FAUNA PAGINATION

                console.log("fauna pagggggggg",srcChild,srcChild.index)
                var pag :PagStore<any> = this.ui._createStoreFromFaunaDoc(srcChild) as any;
                target[key] = pag;
                
                if(edits){
                    console.log("NOT PAG EDIT ADDED YET",key,pag)
                }

            }else if(srcChild instanceof DocStore){ // LINK DOCUMENT AND SET REF OBJECT TO EDITS
                log && console.log("(srcChild instanceof DocStore")
                target[key] = srcChild;
                if(edits){
                    edits[key] = DocStore.CreateRawRefObject(srcChild.ref,srcChild.collection)
                }


            }else if(srcChild && typeof srcChild == "object" && !Array.isArray(srcChild)){ // CONTINUE TO OBJECT
                log && console.log("object",srcChild)

                if(srcChild.data && srcChild.ref){ // FAUNA DOC
                    log && console.log("srcChild && srcChild.data && srcChild.ref",srcChild.ref.id)
                    var foundDoc = this.ui.getDocByRef(srcChild.ref.id);
                    if(foundDoc){
                        window && alert("FOUND DOC")
                        target[key] = foundDoc;
                        foundDoc.set(srcChild);

                    }else{
                        var doc = this.ui._createStoreFromFaunaDoc(srcChild);
                        if(edits){
                            console.log("NOT DOC EDIT ADDED YET", key, doc, edits, storesByKey);
                        }
        
                        target[key] = doc;
                    }

                }else if(srcChild["@ref"]){ // DID NOT USE FAUNA HELPER TO GET DOC OR JUST KEF OF OTHER DOC
                    var foundDoc = this.ui.getDocByRef(srcChild["@ref"].id);
                    
                    if(foundDoc){
                        console.log("FOUND DOC",foundDoc);
                        target[key] = foundDoc;
                        foundDoc.set(srcChild);
                    }else{
                        var doc = this.ui._createStoreFromFaunaDoc(srcChild);
                        console.log("CREATED DOC",doc);
                        target[key] = doc;

                    }
                }else{

                    if(!targetChild){

                        target[key] = {};
                    }

                    if(!editChild && edits){
                        edits[key] = {};
                    }

                    this._setObj(srcChild,target[key], edits ? edits[key] : null, storesByKey ? storesByKey[key] : null,log)
                }   




            }else{ // SET VALUE
                log && console.log("set")

                target[key] = srcChild;
                if(edits){
                    edits[key] = src[key];
                }
            }


        }
    }


    get clone() : this{
        return this.info.clone as any 
    }
    @action _createClone3()  : this{

        if(this.info.instancer){  // can't clone a clone;
            alert("Can't clone an clone")
            return;
        }

        if(!this.info.clone ){
            var clone = new (this as any).constructor(this.ui) as this;
            clone.ui = this.ui;
            this.info.clone = clone;
            clone.info.instancer = this;
            clone.info.ref = this.info.ref;
        
        }
        
        setChildCloneObj(this,this.clone,this.ui);
        return this.info.clone as any;
    }
    @action createClone3() : this{
        alreadyCloned = [];
        return this._createClone3();
    }
    getSaveData(){
        var obj = {} as any;

        for(var key in this){
            if(key != "ui" && key != "info" &&  this[key] !== undefined){
                obj[key] = this[key];
            }
           
        }
        console.log("GETTING SAVE DATA FROM DOC",this,obj);
        
        return obj;
    }
    /* {child:{first:"Jesse",last:"Mason"}} set({child:{first:"Bob"}}) = {child:{first:"Bob",last:"Mason"}} */
    set(obj,log?){
        console.log("DOC SETT",obj,this);
        if(this.info.setFrom2){
            console.log("DOC SETING 2");
            this.setFaunaState(obj);
            return;
        }
        this.info.faunaState = obj;
        this._setObj(obj,this,this.info.edits,this.info.storesBykey,log);
    }

    setFaunaState(obj:FaunaDoc){
        this.info.setFrom2 = true;
        if(!obj){return}


        if(this.info.instancer){
            this.info.instancer.setFaunaState(obj);
        }

        this.info.faunaState = {...this.info.faunaState,...obj};
        // console.log("store this.info.faunaState1",this.info.faunaState,(this as any).city);
        
        setChildFromFaunaObj(obj,this,this.info.storesBykey,this.ui)
        // console.log("this.info.faunaState2",this.info.faunaState,(this as any).city);
        

    }
    convertFromIndex(arr:any,index:string,args:string[]){

    }
    setFaunaStateFromIndex(obj,index,args){
        this.info.setFrom2 = true;
        var newObj = this.convertFromIndex(obj,index,args) as any;
        this.setFaunaState(newObj);
    }

    static CreateInfo (collectionName:string,storesBykey?:any) {
        gblId++; // NEED TO REMOVE FOR SSR
        return {
            ref: null,
            ts: null,
            collection:collectionName,
            edited:false,
            doNotUpload:false,
            deleted:null,
            edits:{},
            clone:null,
            instancer:null,
            storesBykey:storesBykey,
            faunaState:null,
            setFrom2:null,
            gblId:gblId,

        }
    }
    
    static isStoreClass = true;
    
}
export class DocStore extends Store{
    constructor(router:Router){
        super(router);

        if(router){
            router.docs.push(this);
        }
        
    }
    test(values:DeepPartial<this>){
        
    }
    get ref(){
        if(!this.info){
            console.log("NO INFO",this);
            
        }
        // CF WORKER RECEICVES REF IN NON JSON FORMAT
        if(!this.info.ref){
            return null;
        }else if(this.info.ref.id){
            return this.info.ref.id;
        }else{
            return this.info.ref["@ref"].id;
        }
    }
    get collection(){
        return this.info.collection
    }
    get refFaunaObj(){
        return DocStore.CreateRawRefObject(this.ref,this.collection)
    }

    @action setFaunaState(obj:FaunaDoc,useClone?:boolean){

        this.info.setFrom2 = true;
        if(!obj){return}

        var newObj = obj as any;
        if(obj.merge){
            newObj.data = Utils.mergeDeep(obj.data,obj.merge) as any;

            
            
        }


        if(!this.info.ref ){
            // console.log("setting ref",newObj.ref);
            if(newObj.ref){
                this.info.ref = newObj.ref;
                this.info.ts = newObj.ts;
            }else if(newObj["@ref"]){
                alert("why is @ref here")

            }else{
                alert("CONFUSED")
            }

        }

        if(!newObj.data){
            return;
        }

        if(this.info.instancer){
            this.info.instancer.setFaunaState(obj);
        }

        this.info.faunaState = {...this.info.faunaState,...newObj};
        // console.log("this.info.faunaState1",this.ref,this.collection,this.info.faunaState);
        
        // console.log("calling setChildFromFaunaObj newObj.data",newObj.data);
        
        setChildFromFaunaObj(newObj.data,this,this.info.storesBykey,this.ui,useClone)
        // console.log("this.info.faunaState2",this.info.faunaState);

    }


    getSaveDataTest(args?:DeepAny<this>){  
        console.log("getSaveDataTest",args);
        
        var data = {} as any;
        for(var key in args){
            var value = this[key];
            if(value !== undefined){
                data[key] = getSaveData(value)
            }
        }


        var obj = {
            doc:this,
            data:{
                ref:this.ref,
                collection:this.collection,
                data:data
            }
        };
        console.log("obj",obj);
        
        return obj;
    }


    
    getFaunaSaveObj(values:DeepPartial<this>){
        var obj :any = {
            node:this,
            saveObj:{
                ref:this.ref,
                collection:this.collection,
                data:values
            }
        };
        return obj;
    }


    set(obj:FaunaDoc,index?:string,args?:string[],log?:boolean){
        // console.log("SETT",obj,this,Array.isArray(obj),index);
        if(this.info.setFrom2){
            console.log("SETING 2");
            
            if(index){
                this.setFaunaStateFromIndex(obj,index,args)
            }else{
                this.setFaunaState(obj);

            }
            return;
        }
        if(!obj){return}
        if(index){
            var newObj = this.convertFromIndex(obj,index,args) as any;
        }else{
            var newObj = obj as any;
            if(obj.merge){
                newObj.data = Utils.mergeDeep(obj.data,obj.merge) as any;
            }
            
        }

        if(!this.info.ref){
            this.info.ref = newObj.ref;
            this.info.ts = newObj.ts;
        }

        if(!newObj.data){
            console.log("returning");

            return;
        }
        // console.log("YYYY");
        
        this.info.faunaState = {...this.info.faunaState,...newObj};

        if(this.info.instancer instanceof DocStore){
            this.info.instancer.set(obj,index,args);
        }

        super._setObj(newObj.data,this,null,this.info.storesBykey,log);


    } 

    edit(obj:DeepPartial<DocStore>,log?:boolean){
        
        super._setObj(obj,this,this.info.edits,this.info.storesBykey,log);
        this.info.edited = true;
    } 
    delete(){
        if(this.info.instancer){
            this.ui.deleteDoc(this.info.instancer as DocStore);
            // this.info.instancer.info.clone = null
            // this.info.deleted = true;
            return;
        }
        this.ui.deleteDoc(this);
    }
    _getSaveData(edits:any,storesBykey,target){
        console.log("_getSAVEdATA",edits,storesBykey,target);
        
        for(var key in edits){
            console.log("key",key);
            
            var editChild = edits[key];
            var storesByKeyChild = storesBykey[key];

            if(storesByKeyChild){
                if(typeof storesByKeyChild == "function"){
                    if(Array.isArray(editChild)){
                        var arr = [];
                        for (let i = 0; i < editChild.length; i++) {
                            const element = editChild[i] as Store;
                            var saveData = element.getSaveData();                            
                            arr.push(saveData)
                        }
                        target[key] = arr;
                    }else{
                        var saveData = editChild.getSaveData();
                        target[key] = saveData;
                    }
                }else{
                    target[key] = {};
                    this._getSaveData(editChild,storesByKeyChild,target[key]);
                }

            }else{
                target[key] = editChild;
            }


        }
    }
    getSaveData(){ 
        var edits = this.info.edits;
        console.log("edits",edits);
        
        var data;
        if(this.info.storesBykey){
            data = {};
            this._getSaveData(edits,this.info.storesBykey,data)
            console.log("STORES BY KEY RESULT",data);
            
        }else {
            data = edits;
        }
        var obj :any = {
            ref:this.ref,
            collection:this.collection,
            data:data
        };
        
        return obj;
    }

    clearEdits(){
        this.info.edits = {};
    }
    /** Clears edits and sets from faunaState. ERR NEED TO FIX: WILL NOT CLEAR NEW SET KEYS */
    undoEdits(){
        this.clearEdits();
        this.info.edits = {};
        
        // TODO NEED TO REMOVE EDITS THAT ARE NOT SET BY PREV SET DATA
        console.log("undoEdits",this);
        if(this.info.instancer){
            this.set(this.info.instancer.info.faunaState)
        }else{
            this.set(this.info.faunaState)
        }
    }

    deleteClone(){
        if(this.info.clone instanceof DocStore){
            this.info.clone.delete();
        }
        
        this.info.clone = null;
    }
    /** clone will create new instance of class then set from fauna data. 
     * All objects, stores will be cloned. 
     * DOCUMENT STORES WILL NOT BE CLONES */
    createClone(force?:boolean):this{
        if(this.info.setFrom2){
            return this.createClone3();
        }
        console.log("CREATE CLONE",this,force);
        
        if(this.info.clone && !force){
            return this.info.clone as this;
        }
        if(this.info.instancer){ // can't clone a clone;q
            return;
        }

        var clone = new (this as any).constructor() as DocStore;
        clone.ui = this.ui;
        this.info.clone = clone;
        clone.info.instancer = this;
        
        clone.set(this.info.faunaState);
        return clone as any;
    }

    _createClone3():this{
        
        if(this.info.instancer){ // can't clone a clone;
            alert(`Can't Clone a Clone`)
            return;
        }

        if(!this.info.clone ){
            var clone = new (this as any).constructor() as this;
            clone.ui = this.ui;
            this.info.clone = clone;
            clone.info.instancer = this;
            clone.info.ref = this.info.ref;
        

        }

        
        setChildCloneObj(this,this.clone,this.ui)

        return this.info.clone as any;
    }

    static CreateRawRefObject(docId:string,collectionId:string){
        return {
            "@raw":{
                '@ref': {
                    id: docId,
                    collection: {
                      '@ref': {
                        id: collectionId,
                        collection: {
                          '@ref': {
                            id: 'collections'
                          }
                        }
                      }
                    }
                }
            }
        }
    }
    static GetDoc(docs:DocStore[],ref:string){
        return docs.find(doc => doc.ref == ref);
    }
}
export class PagStore<T> extends Store{
    info :StoreInfo = {} as any;
    @state data : T[]
    StoreType : new (ui:Router) => T;

    constructor(StoreType :new (ui:Router) => T,ui:Router){
        super(ui);
        this.StoreType = StoreType;
        ui.pags.push(this);
    }

    delete(){
        if(this.info.instancer){
            this.info.instancer.info.clone = null
            this.info.deleted = true;
            return;
        }
        Utils.RemoveFromArray(this,this.ui.pags)
        // TO DO LOOP THROUGH DATA AND DELETE DOCS
    }

    @action add(node:T,index?:number){
        if(index != undefined){
            this.data.splice(index, 0, node);
        }else{
            this.data.push(node);

        }
    }

    @action _createClone3(){

        if(this.info.instancer){  // can't clone a clone;
            return;
        }

        if(!this.info.clone ){
            var clone = new (this as any).constructor(this.StoreType,this.ui) as this;
            clone.ui = this.ui;
            this.info.clone = clone;
            clone.info.instancer = this;
            clone.info.ref = this.info.ref;
        
        }
        var arr = [];
        for (let i = 0; i < this.data.length; i++) {
            const element = this.data[i];
            arr.push(element)
        }
        
        this.clone.data = setCloneObj(this.data,this.ui) as any;
        // this.clone.data = arr
        console.log("this.clone.data",this.clone.data);
        
        return this.clone as any;
    }

    setFaunaState(obj,useClone?:boolean){
        this.info.setFrom2 = true;
        this.data = [];
        for (let i = 0; i < obj.data.length; i++) {
            const docObj = obj.data[i];
            // console.log("docObj",docObj);
            if(Array.isArray(docObj.data)){
                alert("docObj array error")
            }else if(Array.isArray(docObj)){ // PAGINATE RETURNS ARRAY
                
                var newObj = this.ui.convertFromIndexArray(docObj,obj.index) as any;
                
            }else{ 
                var newObj = docObj;
            }


            if(!newObj.ref["@ref"]){
                alert("REF ERR");
            }

            var doc = this.ui.getDocByRef(newObj.ref["@ref"].id);
            if(!doc){
                doc = this.ui._parseFaunaDoc(newObj,useClone)
            }else{
                doc.setFaunaState(docObj,useClone);

            }
            // console.log("PAG DOC",doc,doc);
            
            this.data.push(doc as any);


        }

        return this.data;
    }

    set(obj){
        console.log("setPAGGG",obj);
        this.data = [];
        for (let i = 0; i < obj.data.length; i++) {
            const docObj = obj.data[i];
            console.log("docObj",docObj);
            
            var doc : any = new this.StoreType(this.ui);
            this.data.push(doc);
            
            
            if(Array.isArray(docObj)){ // PAGINATE RETURNS ARRAY
                console.log("pagIsArr");
                
                doc.set(docObj,obj.index,obj.args);
            }else{ // PAGINATE AND GET
                doc.set(docObj);
            }
            
    
        }

        return this.data;
        // this._setObj(obj.data,this);
    }  
}




